import React, { Component } from "react";

import LoginForm from "./forms/LoginForm";

import AuthModel from "../models/AuthModel";

import { login } from "../services/AuthService";

import restCallController from "../../common/hoc/forms/RestCallController";

import AuthFormHandler from "./forms/handlers/AuthFormHandler";

import { sha256 } from "js-sha256";

import Swal from "sweetalert2";

import {
  Button,
  Typography,
  Hidden,
  withStyles,
} from "@material-ui/core";

import {
  ArrowForward,
  HelpOutline,
} from "@material-ui/icons";


const styles = {

  /* =====================================================
     MAIN PAGE
  ===================================================== */

  page: {
    width: "100vw",

    minHeight: "100vh",

    display: "flex",

    margin: 0,

    padding: 0,

    overflow: "hidden",

    background: "#ffffff",
  },


  /* =====================================================
     LEFT BRAND / INFORMATION SECTION
  ===================================================== */

  leftSection: {
    width: "50%",

    minHeight: "100vh",

    position: "relative",

    overflow: "hidden",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    padding: "60px",

    boxSizing: "border-box",

    background:
      "linear-gradient(135deg, #312e81 0%, #4338ca 50%, #2563eb 100%)",
  },


  leftContent: {
    position: "relative",

    zIndex: 2,

    width: "100%",

    maxWidth: 520,

    color: "#ffffff",
  },


  /* =====================================================
     CONNECTOD LOGO
  ===================================================== */

  logoContainer: {
    display: "inline-flex",

    alignItems: "center",

    justifyContent: "center",

    padding: "10px 16px",

    marginBottom: 28,

    background: "#ffffff",

    borderRadius: 10,

    boxShadow:
      "0 8px 24px rgba(15,23,42,0.12)",
  },

  logo: {
    width: 170,

    height: "auto",

    display: "block",

    objectFit: "contain",
  },


  /* =====================================================
     CFA PORTAL LABEL
  ===================================================== */

  cfaLabel: {
    display: "inline-block",

    padding: "8px 16px",

    marginBottom: 26,

    borderRadius: 30,

    background:
      "rgba(255,255,255,0.10)",

    border:
      "1px solid rgba(255,255,255,0.20)",

    color: "#ffffff",

    fontSize: 12,

    fontWeight: 600,

    letterSpacing: "0.8px",

    textTransform: "uppercase",
  },


  /* =====================================================
     LEFT HEADING
  ===================================================== */

  leftTitle: {
    fontSize: 54,

    lineHeight: 1.05,

    fontWeight: 700,

    letterSpacing: "-2px",

    marginBottom: 25,

    color: "#ffffff",
  },


  leftDescription: {
    maxWidth: 450,

    fontSize: 17,

    lineHeight: 1.7,

    color:
      "rgba(255,255,255,0.82)",

    marginBottom: 35,
  },


  /* =====================================================
     SECURITY BADGE
  ===================================================== */

  securityBox: {
    display: "inline-flex",

    alignItems: "center",

    padding: "13px 18px",

    borderRadius: 12,

    background:
      "rgba(255,255,255,0.10)",

    border:
      "1px solid rgba(255,255,255,0.18)",

    color: "#ffffff",

    fontSize: 13,

    fontWeight: 500,
  },


  securityDot: {
    width: 8,

    height: 8,

    borderRadius: "50%",

    marginRight: 10,

    background: "#86efac",

    boxShadow:
      "0 0 0 4px rgba(134,239,172,0.12)",
  },


  /* =====================================================
     DECORATIVE CIRCLES
  ===================================================== */

  circleOne: {
    position: "absolute",

    width: 500,

    height: 500,

    borderRadius: "50%",

    top: -250,

    left: -250,

    background:
      "rgba(255,255,255,0.045)",
  },


  circleTwo: {
    position: "absolute",

    width: 600,

    height: 600,

    borderRadius: "50%",

    right: -300,

    bottom: -330,

    background:
      "rgba(255,255,255,0.045)",
  },


  circleThree: {
    position: "absolute",

    width: 250,

    height: 250,

    borderRadius: "50%",

    right: 80,

    top: 80,

    border:
      "1px solid rgba(255,255,255,0.08)",
  },


  /* =====================================================
     RIGHT LOGIN SECTION
  ===================================================== */

  rightSection: {
    width: "50%",

    minHeight: "100vh",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    padding: "50px 70px",

    boxSizing: "border-box",

    background: "#ffffff",

    overflowY: "auto",
  },


  loginContainer: {
    width: "100%",

    maxWidth: 430,
  },


  /* =====================================================
     LOGIN HEADER
  ===================================================== */

  header: {
    marginBottom: 32,
  },


  title: {
    fontSize: 34,

    lineHeight: 1.2,

    fontWeight: 700,

    letterSpacing: "-0.6px",

    color: "#111827",

    marginBottom: 10,
  },


  subtitle: {
    color: "#64748b",

    fontSize: 15,

    lineHeight: 1.6,
  },


  /* =====================================================
     LOGIN BUTTON
  ===================================================== */

  loginButton: {
    width: "100%",

    height: 54,

    marginTop: 8,

    borderRadius: 12,

    color: "#ffffff",

    fontSize: 15,

    fontWeight: 600,

    textTransform: "none",

    background:
      "linear-gradient(135deg, #4f46e5 0%, #2563eb 100%)",

    boxShadow:
      "0 10px 25px rgba(37,99,235,0.24)",

    transition: "all 0.2s ease",

    "&:hover": {
      background:
        "linear-gradient(135deg, #4338ca 0%, #1d4ed8 100%)",

      boxShadow:
        "0 14px 30px rgba(37,99,235,0.30)",

      transform: "translateY(-1px)",
    },

    "&:disabled": {
      color: "#ffffff",

      opacity: 0.7,
    },
  },


  /* =====================================================
     FORGOT PASSWORD
  ===================================================== */

  forgotButton: {
    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    width: "100%",

    marginTop: 16,

    padding: "8px 0",

    color: "#4f46e5",

    fontSize: 13,

    fontWeight: 600,

    textTransform: "none",

    "&:hover": {
      background: "transparent",

      color: "#3730a3",
    },
  },


  /* =====================================================
     FOOTER
  ===================================================== */

  footer: {
    textAlign: "center",

    marginTop: 30,

    color: "#94a3b8",

    fontSize: 12,

    lineHeight: 1.5,
  },


  /* =====================================================
     MOBILE
  ===================================================== */

  mobilePage: {
    width: "100%",

    minHeight: "100vh",

    display: "flex",

    alignItems: "center",

    justifyContent: "center",

    padding: "25px 18px",

    boxSizing: "border-box",

    background:
      "linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)",
  },


  mobileLoginContainer: {
    width: "100%",

    maxWidth: 430,

    padding: "32px 24px",

    boxSizing: "border-box",

    background: "#ffffff",

    borderRadius: 18,

    boxShadow:
      "0 15px 45px rgba(15,23,42,0.08)",
  },


  mobileLogoContainer: {
    display: "flex",

    justifyContent: "center",

    marginBottom: 24,
  },


  mobileLogo: {
    width: 160,

    height: "auto",

    display: "block",

    objectFit: "contain",
  },


  mobileTitle: {
    fontSize: 28,
  },
};


class LoginFormComponent extends Component {

  constructor(props) {

    super(props);

    this.state = {
      auth: new AuthModel({}),
    };

    this.authFormHandler =
      new AuthFormHandler(
        this,
        this.state.auth
      );
  }


  /* =====================================================
     LOGIN SUBMIT
  ===================================================== */

  submitLoginForm = () => {

    const {
      handlePromise,
    } = this.props;

    const {
      userEmail,
      password,
    } = this.state.auth;


    if (
      Boolean(userEmail) &&
      Boolean(userEmail.trim()) &&
      this.authFormHandler.validator.allValid()
    ) {

      const loginPayload = {

        ...this.state.auth.toJson(),

        password: sha256(password),

      };


      handlePromise(
        login(loginPayload)
      );

    } else {

      this.authFormHandler.validator.showMessages();

      this.setState({});

    }
  };


  /* =====================================================
     FORGOT PASSWORD
  ===================================================== */

  handleForgotPassword = () => {

    Swal.fire({

      icon: "info",

      title: "Forgot Password?",

      html: `
        <div style="
          color:#64748b;
          font-size:14px;
          line-height:1.7;
          margin-top:8px;
        ">
          Please contact your ConnectOD administrator
          to reset your CFA account password.
        </div>
      `,

      confirmButtonText: "OK",

      confirmButtonColor: "#4f46e5",

      width: 420,

      buttonsStyling: true,

      showCloseButton: true,

    });
  };


  /* =====================================================
     LOGIN CONTENT
  ===================================================== */

  renderLoginContent = (
    isMobile = false
  ) => {

    const {
      auth,
    } = this.state;

    const {
      errors,
      isFetching,
      classes,
    } = this.props;


    return (

      <div
        className={
          isMobile
            ? classes.mobileLoginContainer
            : classes.loginContainer
        }
      >

        {/* =================================================
            MOBILE LOGO
        ================================================= */}

        {isMobile && (

          <div
            className={
              classes.mobileLogoContainer
            }
          >

            <img
              src="/static/media/connectODLogo.4e4933e92130d8bf6e67.png"
              alt="ConnectOD"
              className={
                classes.mobileLogo
              }
            />

          </div>

        )}


        {/* =================================================
            HEADER
        ================================================= */}

        <div className={classes.header}>
          <Typography
            className={
              classes.subtitle
            }
          >
            Sign in to your CFA account to continue
          </Typography>

        </div>


        {/* =================================================
            LOGIN FORM
        ================================================= */}

        <form
          onSubmit={(event) => {

            event.preventDefault();

            this.submitLoginForm();

          }}
        >

          <LoginForm

            model={auth}

            onModelChange={
              this.authFormHandler.onModelChange
            }

            validator={
              this.authFormHandler.validator
            }

            errors={errors}

          />


          {/* =============================================
              SIGN IN BUTTON
          ============================================= */}

          <Button

            type="submit"

            variant="contained"

            disabled={isFetching}

            className={
              classes.loginButton
            }

            endIcon={
              !isFetching &&
              <ArrowForward />
            }

          >

            {isFetching ? (

              <React.Fragment>

                <i
                  className="fa fa-spinner fa-spin"
                  style={{
                    marginRight: 8,
                  }}
                />

                Signing in...

              </React.Fragment>

            ) : (

              "Sign In"

            )}

          </Button>


          {/* =============================================
              FORGOT PASSWORD
          ============================================= */}

          <Button

            type="button"

            className={
              classes.forgotButton
            }

            startIcon={
              <HelpOutline />
            }

            onClick={
              this.handleForgotPassword
            }

          >

            Forgot Password?

          </Button>

        </form>


        {/* =================================================
            FOOTER
        ================================================= */}

        <Typography
          className={
            classes.footer
          }
        >
          Secure access • Your information is protected
        </Typography>

      </div>

    );
  };


  /* =====================================================
     RENDER
  ===================================================== */

  render() {

    const {
      classes,
    } = this.props;


    return (

      <React.Fragment>

        {/* =================================================
            DESKTOP
        ================================================= */}

        <Hidden smDown>

          <div className={classes.page}>

            {/* =============================================
                LEFT SECTION
            ============================================= */}

            <div
              className={
                classes.leftSection
              }
            >

              {/* Decorative elements */}

              <div
                className={
                  classes.circleOne
                }
              />

              <div
                className={
                  classes.circleTwo
                }
              />

              <div
                className={
                  classes.circleThree
                }
              />


              {/* Content */}

              <div
                className={
                  classes.leftContent
                }
              >

                {/* =========================================
                    CONNECTOD LOGO
                ========================================= */}

                <div
                  className={
                    classes.logoContainer
                  }
                >

                  <img
                    src="/static/media/connectODLogo.4e4933e92130d8bf6e67.png"
                    alt="ConnectOD"
                    className={
                      classes.logo
                    }
                  />

                </div>


                


                {/* =========================================
                    HEADING
                ========================================= */}

               
                {/* =========================================
                    DESCRIPTION
                ========================================= */}

                <Typography
                  className={
                    classes.leftDescription
                  }
                >
                  Access the ConnectOD CFA portal securely
                  and manage your account from one place.
                </Typography>


                {/* =========================================
                    SECURITY BADGE
                ========================================= */}

              

              </div>

            </div>


            {/* =============================================
                RIGHT LOGIN SECTION
            ============================================= */}

            <div
              className={
                classes.rightSection
              }
            >

              {this.renderLoginContent(false)}

            </div>

          </div>

        </Hidden>


        {/* =================================================
            MOBILE
        ================================================= */}

        <Hidden mdUp>

          <div
            className={
              classes.mobilePage
            }
          >

            {this.renderLoginContent(true)}

          </div>

        </Hidden>

      </React.Fragment>

    );
  }
}


export default withStyles(styles)(
  restCallController(
    LoginFormComponent
  )
);